import {
  MARKET_FILTER,
  type DashboardSection,
} from '@/features/dashboard/api/schemas'
import { useDashboardStructure } from '@/features/dashboard/api/queries'
import {
  deepDiveById,
  deepDiveTakesMarkets,
  sectionTakes,
} from '@/features/dashboard/model/sections'
import { visibleMarkets } from './filterState'

/** The markets that get a chip in a section; none if its cards ignore them. */
export const useSectionMarkets = (section: DashboardSection) => {
  const { data: dashboard } = useDashboardStructure()
  return sectionTakes(section, MARKET_FILTER)
    ? visibleMarkets(dashboard?.filters?.markets ?? [])
    : undefined
}

/**
 * The markets that get a chip on a deep dive: only a Customers deep dive
 * takes them (whatever its stubs list), and only if one of its cards does.
 */
export const useDeepDiveMarkets = (deepDiveId: string | undefined) => {
  const { data: dashboard } = useDashboardStructure()
  const section = dashboard && deepDiveById(dashboard.sections, deepDiveId)
  return dashboard &&
    section &&
    deepDiveTakesMarkets(dashboard.sections, section.id) &&
    sectionTakes(section, MARKET_FILTER)
    ? visibleMarkets(dashboard.filters?.markets ?? [])
    : undefined
}
